import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SpBaseGridLayoutComponent } from '@common/layouts/sp-base-grid-layout/src/sp-base-grid-layout.component';
import { HeaderComponent } from '../header/header.component';
import { PreviewComponent } from '../preview/preview.component';
import { ContentComponent } from '../content/content.component';
import { BlockDrawerComponent } from '../drawers/block-drawer/block-drawer.component';
import { PageDrawerComponent } from '../drawers/page-drawer/page-drawer.component';
import { NavigationDrawerComponent } from '../drawers/navigation-drawer/navigation-drawer.component';
import { AiChatDrawerComponent } from '../drawers/ai-chat-drawer/ai-chat-drawer.component';
import { SpLoaderComponent } from '@libs/ui/sp-loader/src/sp-loader.component';
import { environment } from '@web-env/environment';

@Component({
    selector: 'web-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SpBaseGridLayoutComponent,
        HeaderComponent,
        PreviewComponent,
        ContentComponent,
        BlockDrawerComponent,
        PageDrawerComponent,
        NavigationDrawerComponent,
        AiChatDrawerComponent,
        SpLoaderComponent,
    ],
})
export class MainComponent {
    public readonly isAiChatEnabled: boolean = environment.aiChat;
}
